import { red, darkRed, lightRed } from '../../colors';

export default {
    paper: {
        display: 'flex',
        alignItems: 'center',
        padding: '6px 16px',
        margin: '10px 0',
    },
    paperAlert: {
        backgroundColor: lightRed,
        color: darkRed,
    },
    icon: {
        marginRight: 10,
    },
    iconAlert: {
        color: red,
    },
};
